import { Component, input } from '@angular/core';

@Component({
  selector: 'lib-auth-page-layout',
  imports: [],
  templateUrl: './auth-page-layout.html',
  styleUrl: './auth-page-layout.scss',
})
export class AuthPageLayout {
  readonly icon = input.required<string>();
  readonly title = input.required<string>();
  readonly subtitle = input<string>();
}
